import React from 'react';
import PropTypes from 'prop-types';

import Button from '../Button/Button';
import * as Styled from './FormSubmissionSuccess.styled';
import ConfirmationIcon from '../Icons/ConfirmationIcon/ConfirmationIcon';

/**
 * A success message for successful form submission
 */
const FormSubmissionSuccess = ({
  title,
  message,
  buttonText,
  onComplete,
  useShopButtons,
  ...buttonProps
}) => (
  <Styled.FormSubmissionSuccess>
    <ConfirmationIcon size="large" />
    {title && <Styled.Title>{title}</Styled.Title>}
    <Styled.Message data-testid="FormSubmissionSuccess__message">
      {message}
    </Styled.Message>
    <div>
      {useShopButtons ? (
        <Styled.ShopButtons />
      ) : (
        <Button
          isFull
          variant="primary"
          size="large"
          onClick={onComplete}
          {...buttonProps}
        >
          {buttonText}
        </Button>
      )}
    </div>
  </Styled.FormSubmissionSuccess>
);

FormSubmissionSuccess.propTypes = {
  /**
   * Title to display
   */
  title: PropTypes.string,
  /**
   * The success message to display
   */
  message: PropTypes.node.isRequired,
  /**
   * Text of the button
   */
  buttonText: PropTypes.string,
  /**
   * callback function on button click
   */
  onComplete: PropTypes.func.isRequired,
  /**
   * renders shop buttons instead of regular button cta
   */
  useShopButtons: PropTypes.bool
};

FormSubmissionSuccess.defaultProps = {
  title: undefined,
  buttonText: 'Close',
  useShopButtons: false
};

export default FormSubmissionSuccess;
